<mat-list *ngIf="!!options">
  <ng-container *ngFor="let entry of $any(options) | keyvalue">
    <h3 matSubheader>{{ $any(entry.key) | uppercase }}</h3>
    <mat-list-item *ngFor="let format of $any(entry.value)" [attr.aria-label]="format.name" role="group">
      <button
        *ngIf="selected | rdsFormatSelectedCount: format as count"
        [@slideInOut]
        class="rds-c-format-count"
        matListIcon
        [attr.data-count]="count"
        (click)="$event.stopPropagation(); remove.emit(format)"
      >
        <span class="cdk-visually-hidden" i18n="action|To remove a format">Remove one of {{ count }} for {{ format.name }}</span>
        <mat-icon>do_not_disturb_on</mat-icon>
      </button>
      <h3 matLine>{{ format.name }}</h3>
      <p matLine *ngIf="format.description as desc">{{ desc }}</p>
      <button mat-icon-button class="format-add-btn" (click)="add.emit(format)">
        <span class="cdk-visually-hidden" i18n="action|To add a format">Add {{ format.name }}</span>
        <mat-icon>add_circle</mat-icon>
      </button>
    </mat-list-item>
  </ng-container>
</mat-list>
